import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChapterLabel, Reveal, ArrowButton } from "@/components/landing/Reveal";
import { IMAGES, waLink, WA_MESSAGES } from "@/lib/site";

const LINES = [
    "It's the table with the perfect view.",
    "The bottle arriving at midnight.",
    "The music getting louder.",
    "The city outside.",
    "And knowing everything has already been taken care of.",
];

const Experience = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

    return (
        <section
            id="experience"
            data-testid="experience-section"
            ref={ref}
            className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36"
        >
            <div className="grid items-center gap-12 md:grid-cols-12 md:gap-16">
                <div className="md:col-span-5">
                    <Reveal>
                        <div className="relative aspect-[4/5] overflow-hidden rounded-sm border border-white/10">
                            <motion.img
                                src={IMAGES.experience}
                                alt="Friends clinking champagne glasses at night"
                                loading="lazy"
                                style={{ y: imgY }}
                                className="absolute inset-0 h-[116%] w-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                        </div>
                    </Reveal>
                </div>

                <div className="md:col-span-7">
                    <Reveal>
                        <ChapterLabel number="Nº 05" title="The Experience" testId="experience-label" />
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="mt-8 font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                            THIS ISN'T JUST{" "}
                            <span className="italic text-gold">A NIGHT OUT.</span>
                        </h2>
                    </Reveal>
                    <div className="mt-10 space-y-4">
                        {LINES.map((line, i) => (
                            <Reveal key={line} delay={0.15 + i * 0.08}>
                                <p
                                    className={`font-serif text-xl italic leading-snug md:text-2xl ${
                                        i === LINES.length - 1
                                            ? "text-gold"
                                            : "text-ivory/75"
                                    }`}
                                >
                                    {line}
                                </p>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.4}>
                        <div className="mt-12">
                            <ArrowButton
                                testId="experience-plan-night-btn"
                                href={waLink(WA_MESSAGES.plan)}
                            >
                                Plan My Night
                            </ArrowButton>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default Experience;
